import React from 'react';
import loadable from '@loadable/component';

import { Layout, SEO, Loading, InfoSection } from '../components';

import { quebecDataSets, quebecLinks } from '../graphs/QuebecDataSet';
// @ts-ignore
const Graph = loadable(() => import('../graphs/Graph'), {
  fallback: <Loading />,
});
// @ts-ignore
import * as styles from './Index.module.scss';

const IndexPage = () => {
  return (
    <Layout links={quebecLinks} title="Quebec">
      <SEO title="Quebec" />
      <div className={styles.IndexWrapper}>
        <InfoSection />
        <div className={styles.GraphWrapper}>
          <Graph dataSet={quebecDataSets} />
        </div>
      </div>
    </Layout>
  );
};

export default IndexPage;
